export class ComplainantTraffic {
    get id() {
        return this.complainantTrafficState.id;
    }
    get diligenceNumber() {
        return this.complainantTrafficState.diligenceNumber;
    }
    get complainantThirId() {
        return this.complainantTrafficState.complainantThirId;
    }
    get vehicle_id() {
        return this.complainantTrafficState.vehicle_id;
    }
    get vehicle_damage() {
        return this.complainantTrafficState.vehicle_damage;
    }
    get trailer_registration() {
        return this.complainantTrafficState.trailer_registration;
    }
    get time_p_alcohol1() {
        return this.complainantTrafficState.time_p_alcohol1;
    }
    get result_p_alcohol1() {
        return this.complainantTrafficState.result_p_alcohol1;
    }
    get time_p_alcohol2() {
        return this.complainantTrafficState.time_p_alcohol2;
    }
    get result_p_alcohol2() {
        return this.complainantTrafficState.result_p_alcohol2;
    }
    get urine_blood_extraction() {
        return this.complainantTrafficState.urine_blood_extraction;
    }
    get optional_part() {
        return this.complainantTrafficState.optional_part;
    }
    get medical_history() {
        return this.complainantTrafficState.medical_history;
    }
    get exceeds_060() {
        return this.complainantTrafficState.exceeds_060;
    }
    get low_influence() {
        return this.complainantTrafficState.low_influence;
    }
    get physical_defects() {
        return this.complainantTrafficState.physical_defects;
    }
    get perform_alcoholemia() {
        return this.complainantTrafficState.perform_alcoholemia;
    }
    get administrative_infection() {
        return this.complainantTrafficState.administrative_infection;
    }
    get complaint() {
        return this.complainantTrafficState.complaint;
    }
    get num_boletin() {
        return this.complainantTrafficState.num_boletin;
    }
    get user_id() {
        return this.complainantTrafficState.user_id;
    }
    get want_declare() {
        return this.complainantTrafficState.want_declare;
    }
    get family_notice() {
        return this.complainantTrafficState.family_notice;
    }
    get medical_examination() {
        return this.complainantTrafficState.medical_examination;
    }
    get interpreter() {
        return this.complainantTrafficState.interpreter;
    }
    get appoints_lawyer() {
        return this.complainantTrafficState.appoints_lawyer;
    }
    get ex_officio() {
        return this.complainantTrafficState.ex_officio;
    }
    get external_aspect_id() {
        return this.complainantTrafficState.external_aspect_id;
    }
    get physical_constitution_id() {
        return this.complainantTrafficState.physical_constitution_id;
    }
    get dress_id() {
        return this.complainantTrafficState.dress_id;
    }
    get face_id() {
        return this.complainantTrafficState.face_id;
    }
    get look_id() {
        return this.complainantTrafficState.look_id;
    }
    get pupils_id() {
        return this.complainantTrafficState.pupils_id;
    }
    get voice_id() {
        return this.complainantTrafficState.voice_id;
    }
    get respiration_id() {
        return this.complainantTrafficState.respiration_id;
    }
    get movements_id() {
        return this.complainantTrafficState.movements_id;
    }
    get ask_react_id() {
        return this.complainantTrafficState.ask_react_id;
    }
    get others_detalles_id() {
        return this.complainantTrafficState.others_detalles_id;
    }
    get behavior_id() {
        return this.complainantTrafficState.behavior_id;
    }
    get driving_license() {
        return this.complainantTrafficState.driving_license;
    }
    get license_expiration() {
        return this.complainantTrafficState.license_expiration;
    }
    set diligenceNumber(diligenceNumber) {
        this.complainantTrafficState.diligenceNumber = diligenceNumber;
    }
    set complainantThirId(complainantThirId) {
        this.complainantTrafficState.complainantThirId = complainantThirId;
    }
    set vehicle_id(vehicle_id) {
        this.complainantTrafficState.vehicle_id = vehicle_id;
    }
    set vehicle_damage(vehicle_damage) {
        this.complainantTrafficState.vehicle_damage = vehicle_damage;
    }
    set trailer_registration(trailer_registration) {
        this.complainantTrafficState.trailer_registration = trailer_registration;
    }
    set time_p_alcohol1(time_p_alcohol1) {
        this.complainantTrafficState.time_p_alcohol1 = time_p_alcohol1;
    }
    set result_p_alcohol1(result_p_alcohol1) {
        this.complainantTrafficState.result_p_alcohol1 = result_p_alcohol1;
    }
    set time_p_alcohol2(time_p_alcohol2) {
        this.complainantTrafficState.time_p_alcohol2 = time_p_alcohol2;
    }
    set result_p_alcohol2(result_p_alcohol2) {
        this.complainantTrafficState.result_p_alcohol2 = result_p_alcohol2;
    }
    set urine_blood_extraction(urine_blood_extraction) {
        this.complainantTrafficState.urine_blood_extraction = urine_blood_extraction;
    }
    set optional_part(optional_part) {
        this.complainantTrafficState.optional_part = optional_part;
    }
    set medical_history(medical_history) {
        this.complainantTrafficState.medical_history = medical_history;
    }
    set exceeds_060(exceeds_060) {
        this.complainantTrafficState.exceeds_060 = exceeds_060;
    }
    set low_influence(low_influence) {
        this.complainantTrafficState.low_influence = low_influence;
    }
    set physical_defects(physical_defects) {
        this.complainantTrafficState.physical_defects = physical_defects;
    }
    set perform_alcoholemia(perform_alcoholemia) {
        this.complainantTrafficState.perform_alcoholemia = perform_alcoholemia;
    }
    set administrative_infection(administrative_infection) {
        this.complainantTrafficState.administrative_infection = administrative_infection;
    }
    set complaint(complaint) {
        this.complainantTrafficState.complaint = complaint;
    }
    set num_boletin(num_boletin) {
        this.complainantTrafficState.num_boletin = num_boletin;
    }
    set user_id(user_id) {
        this.complainantTrafficState.user_id = user_id;
    }
    set want_declare(want_declare) {
        this.complainantTrafficState.want_declare = want_declare;
    }
    set family_notice(family_notice) {
        this.complainantTrafficState.family_notice = family_notice;
    }
    set medical_examination(medical_examination) {
        this.complainantTrafficState.medical_examination = medical_examination;
    }
    set interpreter(interpreter) {
        this.complainantTrafficState.interpreter = interpreter;
    }
    set appoints_lawyer(appoints_lawyer) {
        this.complainantTrafficState.appoints_lawyer = appoints_lawyer;
    }
    set ex_officio(ex_officio) {
        this.complainantTrafficState.ex_officio = ex_officio;
    }
    set external_aspect_id(external_aspect_id) {
        this.complainantTrafficState.external_aspect_id = external_aspect_id;
    }
    set physical_constitution_id(physical_constitution_id) {
        this.complainantTrafficState.physical_constitution_id = physical_constitution_id;
    }
    set dress_id(dress_id) {
        this.complainantTrafficState.dress_id = dress_id;
    }
    set face_id(face_id) {
        this.complainantTrafficState.face_id = face_id;
    }
    set look_id(look_id) {
        this.complainantTrafficState.look_id = look_id;
    }
    set pupils_id(pupils_id) {
        this.complainantTrafficState.pupils_id = pupils_id;
    }
    set voice_id(voice_id) {
        this.complainantTrafficState.voice_id = voice_id;
    }
    set respiration_id(respiration_id) {
        this.complainantTrafficState.respiration_id = respiration_id;
    }
    set movements_id(movements_id) {
        this.complainantTrafficState.movements_id = movements_id;
    }
    set ask_react_id(ask_react_id) {
        this.complainantTrafficState.ask_react_id = ask_react_id;
    }
    set others_detalles_id(others_detalles_id) {
        this.complainantTrafficState.others_detalles_id = others_detalles_id;
    }
    set behavior_id(behavior_id) {
        this.complainantTrafficState.behavior_id = behavior_id;
    }
    set driving_license(driving_license) {
        this.complainantTrafficState.driving_license = driving_license;
    }
    set license_expiration(license_expiration) {
        this.complainantTrafficState.license_expiration = license_expiration;
    }
    constructor(complainantTrafficState) {
        this.complainantTrafficState = complainantTrafficState;
    }
    getState() {
        return this.complainantTrafficState;
    }
}
